import { profilesClient } from "@eolas-medical/core";

const useGetLocations = () => {
  return {
    getLocations: (query: string) => profilesClient.getLocations(query),
  };
};

export default useGetLocations;
